<template>
  <div>
    <div class="result">
      <div style="height:50px"></div>
      <div class="result_title">
        <div class="container-result">
          <h3>你家的地理位置安全嗎?</h3>
        </div>
      </div>
      <div id="map"></div>
      
      <div class="container-result">
        <p class="mb-3 mt-3">地震來臨時，靠近活動斷層的房屋可能有破損、倒塌風險，位於土壤液化潛勢區的房屋則可能有傾斜風險。</p>
        <h3 class="mb-1">你家耐震能力如何？</h3>

        <div class="circles mb-3">
          <div class="circle">
            <div class="circle_red">
          </div>
          <div class="cricle_container">
            <p>可能有立即危險</p><p>{{ this.circle_red }} 處</p>
          </div>
         </div>

          <div class="circle">
            <div class="circle_orange">
            </div>
            <div class="cricle_container">
              <p>需稍加留意</p><p>{{ this.circle_orange }} 處</p>
            </div>
          </div>

          <div class="circle">
            <div class="circle_green">
            </div>
            <div class="cricle_container">
              <p>暫無疑慮</p><p>{{ this.circle_green }} 處</p>
            </div>
          </div>
        </div>
        <!-- Answer2 -->
        <div class="answer2">
          <div class="answer2_title" v-if="this.$store.state.answers.answer2 === 'isActive4'
          || this.$store.state.answers.answer2 === 'isActive5'">
            <div class="circle_green"></div><p>你家建築物外型的耐震度較高</p>
          </div>

          <div class="answer2_title" v-else-if="this.$store.state.answers.answer2 === 'isActive1'
          || this.$store.state.answers.answer2 === 'isActive2'
          || this.$store.state.answers.answer2 === 'isActive3'">
            <div class="circle_orange"></div><p>你家建築物外型的耐震度較低</p>
          </div>

          <div class="answer2_title answer2_title-default" v-else>
            <p>建築物外型</p>
          </div>         

          <div class="answer_imageContainer">
            <div class="answer2_image">
              <img class="house" id="house" :src="this.answer2_image" alt="建築物外型">
              <img class="crack" id="crack" :src="this.answer2_imageCover" alt="建築物外型" v-show="isCrack2">
              <div class="worning" id="worning_1"></div>
              <div class="worning" id="worning_2"></div>
            </div>
            <p>{{ this.answer2_description }}</p>
          </div>
          <!-- <img class="answer2_image" :src="this.answer2_image" alt="">
          <p>{{ this.answer2_description }}</p> -->
        </div>

        <!-- Answer3 -->
        <div class="answer3">
          <div class="answer3_title" v-if="this.$store.state.answers.answer3 === 'isActive1'
          || this.$store.state.answers.answer3 === 'isActive2'
          || this.$store.state.answers.answer3 === 'isActive3'
          || this.$store.state.answers.answer3 === 'isActive4'">
            <div class="circle_orange"></div><p>你家建築物可能有軟弱底層</p>
          </div>

          <div class="answer3_title answer3_title-default" v-else>
            <p>建築物軟弱底層</p>
          </div>         

          <div class="answer_imageContainer">
            <div class="answer3_image">
              <img class="dhouse" id="dhouse" :src="this.answer3_image" alt="建築物結構">
              <img class="danger" id="danger" :src="this.answer3_imageCover" alt="建築物結構" v-show="isCrack3">
            </div>
            <p>{{ this.answer3_description }}</p>
          </div>
        </div>

        <!-- Answer4 -->
        <div class="answer4">

          <div class="answer4_title" v-if="this.$store.state.answers.answer4 === 'isActive7'">
            <div class="circle_green"></div><p>地震後，你家柱子有細小的水平向裂紋</p>
          </div>

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive8'">
            <div class="circle_green"></div><p>地震後，你家柱子沒有新增任何裂紋</p>
          </div>

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive6'">
            <div class="circle_orange"></div><p>地震後，你家柱子有不連續的垂直向、斜向裂縫</p>
          </div>   

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive1'">
            <div class="circle_red"></div><p>地震後，你家柱子有連續的垂直向開裂</p>
          </div>     

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive2'">
            <div class="circle_red"></div><p>地震後，你家柱子有連續的斜向開裂</p>
          </div>  

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive3'">
            <div class="circle_red"></div><p>地震後，你家柱子有連續的X形開裂</p>
          </div>  

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive4'">
            <div class="circle_red"></div><p>地震後，你家柱子有鋼筋外露情形</p>
          </div>  

          <div class="answer4_title" v-else-if="this.$store.state.answers.answer4 === 'isActive5'">
            <div class="circle_red"></div><p>地震後，你家柱子有連續的V形開裂</p>
          </div>  
          <div class="answer_imageContainer">
            <img class="answer4_image" :src="this.answer4_image" alt="柱子">
            <p>{{ this.answer4_description }}</p>
          </div>
        </div>

        <!-- Answer5 -->
        <div class="answer5">

          <div class="answer5_title" v-if="this.$store.state.answers.answer5 === 'isActive6'">
            <div class="circle_green"></div><p>地震後，你家屋樑有垂直向不連續的裂紋</p>
          </div>

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive7'">
            <div class="circle_green"></div><p>地震後，你家屋樑沒有新增任何裂紋</p>
          </div>

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive2'">
            <div class="circle_orange"></div><p>地震後，你家屋樑有明顯而連續的斜向裂縫</p>
          </div>   

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive3'">
            <div class="circle_orange"></div><p>地震後，你家屋樑有明顯而連續的X形裂縫</p>
          </div>     

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive4'">
            <div class="circle_orange"></div><p>地震後，你家屋樑有明顯而連續的水平向裂縫</p>
          </div>  

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive5'">
            <div class="circle_orange"></div><p>地震後，你家屋樑有明顯而連續的垂直向裂縫</p>
          </div>  

          <div class="answer5_title" v-else-if="this.$store.state.answers.answer5 === 'isActive1'">
            <div class="circle_red"></div><p>地震後，你家屋樑的鋼筋外露</p>
          </div>  
          
          <div class="answer_imageContainer">
            <img class="answer5_image" :src="this.answer5_image" alt="屋樑">
            <p>{{ this.answer5_description }}</p>
          </div>
        </div>
        
        <h3 class="mt-3 mb-3">你可以怎麼做？</h3>
        <p>若民眾對自家老屋耐震能力有疑慮，可透過內政部營建署推動的老屋耐震計畫，申請老屋耐震安檢補助。對於檢測後有耐震疑慮的房屋，營建署也在2019年推出「全國建築物耐震安檢暨輔導重建補強計畫」，將輔導、補助房屋進行階段性補強措施。</p>

        <p class="bold m-0">Q1：誰能申請補助？</p>
        <p>民國88年12月31日前取得建造執照之合法住宅。</p>

        <p class="bold m-0">Q2：哪些老屋無法申請政府補助老屋耐震安檢？</p>
        <p>（一）已進行都市更新程序（業經核定都市更新事業概要或計畫者）。</p>
        <p>（二）非依都市更新程序，欲辦理重建且已申請建造執照者。</p>
        <p>（三）經災害後危險建築物緊急評估辦法第6條規定判定，有危險之虞者，並已於建築物主要出入口及損害區域適當位置，張貼危險標誌者。</p>
        <p>（四）整棟建物之住宅使用未達1/2者。</p>
        <p>（五）申請耐震能力評估項目已獲政府機關補助者。</p>

        <p class="bold m-0">Q3：申請方式為何？</p>
        <p>由民眾向當地直轄市、縣（市）政府提出申請。已成立管理委員會之社區由管委會代表申請；未成立管理委員會者，應有一定區分所有權人比例同意並推派一人代表申請，實際之同意比例、人數及申請方式，將由住宅建物座落之各直轄市、縣(市)政府於受理時公告周知。</p>

        <p class="bold m-0">Q4：政府會補助多少費用？</p>
        <p>老屋耐震能力初步評估的補助費用，總樓板面積3,000平方公尺以上者，每棟補助1.5萬元，3,000平方公尺以下者，每棟補助1.2萬元（2019年5月30日更新版）。</p>

        <p>耐震能力詳細評估的費用，政府將補助45%，至多不超過60萬。階段性補強的費用，每棟最多補助45%，補助上限為220萬元。</p>

        <p>更多與老屋耐震安檢計畫相關的資訊及各縣市負責單位的連絡電話，請參照內政部營建署<a href="https://www.cpami.gov.tw/%E6%9C%80%E6%96%B0%E6%B6%88%E6%81%AF/%E6%A5%AD%E5%8B%99%E6%96%B0%E8%A8%8A/19798-%E8%80%81%E8%88%8A%E4%BD%8F%E5%AE%85%E8%80%90%E9%9C%87%E5%AE%89%E6%AA%A2%E5%B0%88%E5%8D%80.html" class="colorGreen" title="老舊住宅耐震安檢專區">老舊住宅耐震安檢專區</a></p>

        <h6 class="colorGray">資料來源：<br>經濟部中央地質調查所、國家地震工程研究中心、內政部營建署</h6>
      </div>
    </div>
    
    <div style="width:100%;background:white;">
      <Relate :isActive5="true" style="margin-top:0;"/>
      <Comment href="https://udn.com/newmedia/921/safehome/"></Comment>
      <Logo></Logo>
      <Author>
        <p>統籌製作：謝汶均</p>
        <p>插畫：黃微庭</p>
        <p>設計：蘇士堯</p>
        <p>網頁製作：謝化挺</p>
        <p>數位行銷：陳雨暄、劉時均</p>
        <p>製作單位：聯合報新媒體中心、視覺設計中心</p>
        <p>監製：聯合報新聞部</p>
        <p>2019.09.16</p>
      </Author>
      <Footer></Footer>
    </div>

    <div id="legend" :class="{'legend-close': !this.isLegend}">
      <div class="legend_close" :class="{'legend_close-close': !this.isLegend}" @click="legend_close" :title="[ this.isLegend ? '關閉圖例' : '展開圖例']">
        <div class="legend_close_1" v-if="this.isLegend"></div>
        <div class="legend_close_2" v-if="this.isLegend"></div>
        <div class="faIcon">
          <i class="fas fa-angle-left" v-if="!this.isLegend"></i>
        </div>
      </div>
      <div class="legend_container" v-if="this.isLegend">
        <div class="legend1">
          <div class="legend1_legend"></div><div class="legend1_text">第一類活動斷層<br>(過去1萬年內曾活動者)</div>
        </div>
        <div class="legend2">
          <div class="legend2_legend"></div><div class="legend2_text">第二類活動斷層<br>(過去10萬年至1萬年內曾活動者)</div>
        </div>
        <div class="legend3">
          <div class="legend3_legend"></div><div class="legend3_text">掩覆或推測斷層</div>
        </div>
        <div class="legend4">
          <div class="legend4_legend"></div><div class="legend4_text">土壤液化高潛勢區</div>
        </div>
        <div class="legend5">
          <div class="legend5_legend"></div><div class="legend5_text">土壤液化中潛勢區</div>
        </div>
        <div class="legend6">
          <div class="legend6_legend"></div><div class="legend6_text">土壤液化低潛勢區</div>
        </div>
      </div>
    </div>
    <GeneralWidget></GeneralWidget>


  </div>
</template>

<script>
import Logo from '../../../general_components/Logo.vue'
import Author from '../../../general_components/Author.vue'
import Footer from '../../../general_components/Footer.vue'
import Relate from '../../../general_components/Relate.vue'
import Comment from '../../../general_components/Comment.vue'
import GeneralWidget from '../../../general_components/GeneralWidget.vue'

export default {
  name: 'Result',
  components:{
    Logo,
    Author,
    Footer,
    Relate,
    Comment,
    GeneralWidget
  },
  data() {
    return {
      isLegend: true,
      isCrack2: false,
      isCrack3: false
    }
  },
  props: {
    bar: Object
  },
  computed: {
    isShow() {
      if(this.$store.state.answers.answer1 
      && this.$store.state.answers.answer2
      && this.$store.state.answers.answer3
      && this.$store.state.answers.answer4
      && this.$store.state.answers.answer5) {
        return true
      }
    return false
    },
    circle_red() {
      let number = 0
      if(this.$store.state.answers.answer4 === 'isActive1'
      || this.$store.state.answers.answer4 === 'isActive2'
      || this.$store.state.answers.answer4 === 'isActive3'
      || this.$store.state.answers.answer4 === 'isActive4'
      || this.$store.state.answers.answer4 === 'isActive5') {
        number += 1
      }
      if(this.$store.state.answers.answer5 === 'isActive1') {
        number += 1
      }
      return number
    },
    circle_orange() {
      let number = 0
      if(this.$store.state.answers.answer2 === 'isActive1'
      || this.$store.state.answers.answer2 === 'isActive2'
      || this.$store.state.answers.answer2 === 'isActive3') {
        number += 1
      }
      if(this.$store.state.answers.answer3 === 'isActive1'
      || this.$store.state.answers.answer3 === 'isActive2'
      || this.$store.state.answers.answer3 === 'isActive3'
      || this.$store.state.answers.answer3 === 'isActive4') {
        number += 1
      }
      if(this.$store.state.answers.answer4 === 'isActive6') {
        number += 1
      }
      if(this.$store.state.answers.answer5 === 'isActive2'
      || this.$store.state.answers.answer5 === 'isActive3'
      || this.$store.state.answers.answer5 === 'isActive4'
      || this.$store.state.answers.answer5 === 'isActive5') {
        number += 1
      }
      return number
    },
    circle_green() {
      let number = 0
      if(this.$store.state.answers.answer2 === 'isActive4'
      || this.$store.state.answers.answer2 === 'isActive5') {
        number += 1
      }
      if(this.$store.state.answers.answer4 === 'isActive7'
      || this.$store.state.answers.answer4 === 'isActive8') {
        number += 1
      }
      if(this.$store.state.answers.answer5 === 'isActive6'
      || this.$store.state.answers.answer5 === 'isActive7') {
        number += 1
      }
      return number
    },
    answer2_image() {
      switch (this.$store.state.answers.answer2) {
        case 'isActive1':
          return 'static/image/q2_1.svg'
        case 'isActive2':
          return 'static/image/q2_2.svg'
        case 'isActive3':
          return 'static/image/q2_3.svg'
        case 'isActive4':
          return 'static/image/q2_4.svg'
        case 'isActive5':
          return 'static/image/q2_5.svg'
        case 'isActive6':
          return 'static/image/default.svg'
      }
    },
    answer2_description() {
      switch (this.$store.state.answers.answer2) {
        case 'isActive1':
          return '地震時，T型建物的轉角處承受較多的擠壓或拉扯力量，容易發生破壞。'
        case 'isActive2':
          return '地震時，ㄇ型建物的轉角處承受較多的擠壓或拉扯力量，容易發生破壞。'
        case 'isActive3':
          return '地震時，L型建物的轉角處承受較多的擠壓或拉扯力量，容易發生破壞。'
        case 'isActive4':
          return '平面形狀為一字型的建物，地震時安全性較高。'
        case 'isActive5':
          return '平面形狀為方型的建物，地震時安全性較高。'
        case 'isActive6':
          return '購屋時，盡量避開ㄇ型、T型、L型等建物。地震時，此類建物的轉角處承受較多的擠壓或拉扯力量，容易發生破壞。'
      }
    },
    answer2_imageCover() {
      switch (this.$store.state.answers.answer2) {
        case 'isActive1':
          return 'static/image/q2_1_ans.svg'
        case 'isActive2':
          return 'static/image/q2_2_ans.svg'
        case 'isActive3':
          return 'static/image/q2_3_ans.svg'
      }
    },
    answer3_image() {
      switch (this.$store.state.answers.answer3) {
        case 'isActive1':
          return 'static/image/q3_1.svg'
        case 'isActive2':
          return 'static/image/q3_2.svg'
        case 'isActive3':
          return 'static/image/q3_3.svg'
        case 'isActive4':
          return 'static/image/q3_4.svg'
        case 'isActive5':
          return 'static/image/default.svg'
      }
    },
    answer3_description() {
      switch (this.$store.state.answers.answer3) {
        case 'isActive1':
          return '若一樓為設置車庫而將牆壁打除，地震時，地震摧毀的能量可能會集中在一樓，造成該樓層先坍塌，而其他樓層也跟著倒塌。'
        case 'isActive2':
          return '若一樓大廳過度挑高，卻未加粗柱子或增設牆壁量，地震時，地震摧毀的能量可能會集中在一樓，造成該樓層先坍塌，而其他樓層也跟著倒塌。'
        case 'isActive3':
          return '緊鄰街道的一樓商家常將牆壁打除，而以大片的透光玻璃替代，使得一樓的耐震力變差。'
        case 'isActive4':
          return '懸臂式建築一樓鄰馬路邊的樓板懸空，懸空處沒有柱子分擔樓板重量與地震力，所以底層的耐震性通常不佳。'
        case 'isActive5':
          return '若建築物某一層的牆量不足、樓層過度挑高，在結構上，該樓層就會明顯較其他樓層軟落，地震時，地震摧毀的能量可能會集中在這層樓。'
      }
    },
    answer3_imageCover() {
      switch (this.$store.state.answers.answer3) {
        case 'isActive1':
          return 'static/image/q3_1_ans.svg'
        case 'isActive2':
          return 'static/image/q3_2_ans.svg'
        case 'isActive3':
          return 'static/image/q3_3_ans.svg'
        case 'isActive4':
          return 'static/image/q3_4_ans.svg'
      }
    },
    answer4_image() {
      switch (this.$store.state.answers.answer4) {
        case 'isActive1':
          return 'static/image/q4_1.svg'
        case 'isActive2':
          return 'static/image/q4_2.svg'
        case 'isActive3':
          return 'static/image/q4_3.svg'
        case 'isActive4':
          return 'static/image/q4_4.svg'
        case 'isActive5':
          return 'static/image/q4_5.svg'
        case 'isActive6':
          return 'static/image/q4_6.svg'
        case 'isActive7':
          return 'static/image/q4_7.svg'
        case 'isActive8':
          return 'static/image/q4_8.svg'
      }
    },
    answer4_description() {
      switch (this.$store.state.answers.answer4) {
        case 'isActive1':
          return '若裂縫可塞入一枚50元硬幣，應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive2':
          return '若裂縫可塞入一枚50元硬幣，應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive3':
          return '若裂縫可塞入一枚50元硬幣，應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive4':
          return '應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive5':
          return '若裂縫可塞入一枚50元硬幣，應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive6':
          return '若裂縫可塞入一枚50元硬幣，應通知專業技師前來檢查，確認結構是否須修復補強。'
        case 'isActive7':
          return '不影響結構安全，可自行修補。'
        case 'isActive8':
          return '若柱子在震後無新增的開裂、裂縫、裂紋，顯示建物的柱子結構暫無疑慮。'
      }
    },
    answer5_image() {
      switch (this.$store.state.answers.answer5) {
        case 'isActive1':
          return 'static/image/q5_1.svg'
        case 'isActive2':
          return 'static/image/q5_2.svg'
        case 'isActive3':
          return 'static/image/q5_3.svg'
        case 'isActive4':
          return 'static/image/q5_4.svg'
        case 'isActive5':
          return 'static/image/q5_5.svg'
        case 'isActive6':
          return 'static/image/q5_6.svg'
        case 'isActive7':
          return 'static/image/q5_7.svg'
      }
    },
    answer5_description() {
      switch (this.$store.state.answers.answer5) {
        case 'isActive1':
          return '應立即離開屋內，並儘速通知專業技師前往檢查房屋是否有崩塌之虞。'
        case 'isActive2':
          return '若裂縫可塞入一枚50元硬幣，應通知專業技師前來檢查，確認結構是否須修復補強。'
        case 'isActive3':
          return '若裂縫可塞入一枚50元硬幣，應通知專業技師前來檢查，確認結構是否須修復補強。'
        case 'isActive4':
          return '若裂縫可塞入一枚50元硬幣，應通知專業技師前來檢查，確認結構是否須修復補強。'
        case 'isActive5':
          return '若裂縫可塞入一枚50元硬幣，應通知專業技師前來檢查，確認結構是否須修復補強。'
        case 'isActive6':
          return '不影響結構安全，可自行修補。'
        case 'isActive7':
          return '若屋樑在震後無新增的開裂、裂縫、裂紋，顯示建物的屋樑結構暫無疑慮。'
      }
    }
  },
  mounted() {
    let vm = this
    if(this.$store.state.answers.answer1 
      && this.$store.state.answers.answer2
      && this.$store.state.answers.answer3
      && this.$store.state.answers.answer4
      && this.$store.state.answers.answer5) {
      
    }else{
      this.$router.push({path: '/'})
      return
    }
    if(this.bar){
      this.bar._container.parentNode.style.opacity = 0
    }
    document.querySelector('.topBar').style.background = 'transparent'

    var map = new google.maps.Map(document.getElementById('map'), {
      // center: {lat: 25.0568475, lng: 121.6456691},
      zoom: 11,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT
      },
      styles: [
        {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "saturation": "-20"
              },
              {
                  "lightness": "18"
              }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "administrative.neighborhood",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              },
              {
                  "hue": "#0600ff"
              }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "geometry",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 65
              },
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 51
              },
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "road.highway.controlled_access",
          "elementType": "labels.text.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 30
              },
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 40
              },
              {
                  "visibility": "on"
              }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "visibility": "simplified"
              }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
              {
                  "hue": "#00c7ff"
              },
              {
                  "lightness": "-10"
              },
              {
                  "saturation": "-71"
              },
              {
                  "visibility": "simplified"
              }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "lightness": -25
              },
              {
                  "saturation": -100
              }
          ]
        },
        {
          featureType: 'transit',
          stylers: [{visibility: 'off'}]
        }
      ]

    })
    var geocoder = new google.maps.Geocoder()
    var address = this.$store.state.answers.answer1
    var infowindow = new google.maps.InfoWindow()

    var data_layer_fault = new google.maps.Data({map: map})
    var data_layer_earth_low = new google.maps.Data({map: map})
    var data_layer_earth_mid = new google.maps.Data({map: map})
    var data_layer_earth_high = new google.maps.Data({map: map})
    
    function panBy(map){
      map.panBy(75, 75)
    }

    function initMap(callback) {
      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == 'OK') {
          // console.log(results)
          map.setCenter(results[0].geometry.location)
          var marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location,
              icon: {
                url: 'static/image/pin.svg',
                scaledSize: new google.maps.Size(50, 50)
              },
              optimized: false
          })
          callback(map)
        } else {
          // console.log(status)
        }
      })

      var lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        scale: 4
      };

      // 斷層區
      data_layer_fault.loadGeoJson('static/GeoJSON.json')
      data_layer_fault.setStyle(function(feature){
        if((feature.h.FAULT_TYPE.indexOf('第一類') !== -1) && feature.h.observe === '觀察'){
          return {
            strokeWeight: 3,
            strokeOpacity: 1,
            strokeColor: '#0D378C',
          }
        } else if ((feature.h.FAULT_TYPE.indexOf('第一類') !== -1) && ( feature.h.observe === '掩覆' || feature.h.observe === '推測')) {
          return {
            strokeOpacity: 0,
            strokeColor: '#0D378C',
            icons: [{
              icon: lineSymbol,
              offset: '0',
              repeat: '20px'
            }]
          }
        } else if ((feature.h.FAULT_TYPE.indexOf('第二類') !== -1) && feature.h.observe === '觀察') {
          return {
            strokeWeight: 3,
            strokeOpacity: 1,
            strokeColor: '#0080FF',
          }
        } else if ((feature.h.FAULT_TYPE.indexOf('第二類') !== -1) && ( feature.h.observe === '掩覆' || feature.h.observe === '推測')) {
          return {
            strokeOpacity: 0,
            strokeColor: '#0080FF',
            icons: [{
              icon: lineSymbol,
              offset: '0',
              repeat: '20px'
            }]
          }
        }      
      })

      // 土壤液化區-低潛勢
      data_layer_earth_low.loadGeoJson('static/台北_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/新竹_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/台中_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/彰化_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/雲林_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/嘉義_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/台南_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/高雄_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/屏東_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/恆春_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/宜蘭_低潛勢.json')
      data_layer_earth_low.loadGeoJson('static/花蓮_低潛勢.json')
      data_layer_earth_low.setStyle({
        strokeColor: '#000000',
        strokeWeight: .5,
        strokeOpacity: 1,
        fillColor: '#FFC2C2',
        fillOpacity: .3
      })

      // 土壤液化區-中潛勢
      data_layer_earth_mid.loadGeoJson('static/台北_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/新竹_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/台中_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/彰化_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/雲林_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/嘉義_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/台南_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/高雄_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/屏東_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/恆春_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/宜蘭_中潛勢.json')
      data_layer_earth_mid.loadGeoJson('static/花蓮_中潛勢.json')
      data_layer_earth_mid.setStyle({
        strokeColor: '#000000',
        strokeWeight: .5,
        strokeOpacity: 1,
        fillColor: '#FF6D6D',
        fillOpacity: .5
      })

      // 土壤液化區-高潛勢
      data_layer_earth_high.loadGeoJson('static/台北_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/新竹_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/台中_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/彰化_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/雲林_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/嘉義_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/台南_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/高雄_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/屏東_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/恆春_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/宜蘭_高潛勢.json')
      data_layer_earth_high.loadGeoJson('static/花蓮_高潛勢.json')
      data_layer_earth_high.setStyle({
        strokeColor: '#000000',
        strokeWeight: .5,
        strokeOpacity: 1,
        fillColor: '#D40000',
        fillOpacity: .6
      })

      map.addListener('click', (event)=>{
        event.preventDefault()
      })

      if(window.innerWidth>=768){
        data_layer_fault.addListener('mouseover', (event)=>{
          var coordinate = {lat: event.latLng.lat(), lng: event.latLng.lng()}
          infowindow.setPosition(coordinate)
          infowindow.setContent(
            `<p>斷層：${event.feature.h.Name}</p>
            <p>類別：${event.feature.h.FAULT_TYPE}</p>
            <p>類型：${event.feature.h.observe}</p>
            `)
          // document.querySelector('.gm-style-iw.gm-style-iw-c').style.background = 'red'
          // console.log(document.querySelector('.gm-style-iw'))
          infowindow.open(map)
        })

        data_layer_fault.addListener('mouseout', (event)=>{
          infowindow.close(map)
        })
      }else{
        data_layer_fault.addListener('click', (event)=>{
          var coordinate = {lat: event.latLng.lat(), lng: event.latLng.lng()}
          infowindow.setPosition(coordinate)
          infowindow.setContent(
            `<p>斷層：${event.feature.h.Name}</p>
            <p>類別：${event.feature.h.FAULT_TYPE}</p>
            <p>類型：${event.feature.h.observe}</p>
            `)
          // document.querySelector('.gm-style-iw.gm-style-iw-c').style.background = 'red'
          // console.log(document.querySelector('.gm-style-iw'))
          infowindow.open(map)
        })
      }
      

      //legend
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(document.getElementById('legend'))
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(document.querySelector('.legend_open'))
    }
    initMap(panBy)
    

    var controller_onEnter = new ScrollMagic.Controller({globalSceneOptions: {triggerHook:'onEnter'}})

    if(this.$store.state.answers.answer2 == 'isActive1'
    || this.$store.state.answers.answer2 == 'isActive2'
    || this.$store.state.answers.answer2 == 'isActive3') {

      const crack = document.getElementById('crack');
      const house = document.getElementById('house');
      const worning_1 = document.getElementById('worning_1');
      const worning_2 = document.getElementById('worning_2');

      const tl = new TimelineMax();

      var sceneAns2 = new ScrollMagic.Scene({triggerElement: '.answer2', duration: 0, offset: window.innerHeight*0.5})
      sceneAns2.on('enter', function(){
        vm.isCrack2 = true
        tl.fromTo(house, 0.02, {x:-2}, {x:+2, clearProps:"x", repeat:40})
        .fromTo(crack, 1, {opacity:0}, {opacity:1})
        .fromTo(worning_1,1 ,{backgroundColor:"rgb(255, 0, 0)",opacity:.7, scale:0}, {opacity:0, scale:1, repeat:-1})
        .fromTo(worning_2,1 ,{backgroundColor:"rgb(255, 0, 0)",opacity:.8, scale:0}, {opacity:0, scale:.8, repeat:-1}, "-=0.8")
        sceneAns2.destroy()
      })
      // .addIndicators({})
      .addTo(controller_onEnter)
    }

    if(this.$store.state.answers.answer3 == 'isActive1'
    || this.$store.state.answers.answer3 == 'isActive2'
    || this.$store.state.answers.answer3 == 'isActive3'
    || this.$store.state.answers.answer3 == 'isActive4') {
      const danger = document.getElementById('danger');
      
      var sceneAns3 = new ScrollMagic.Scene({triggerElement: '.answer3', duration: 0, offset: window.innerHeight*0.5})
      sceneAns3.on('enter', function(){
        vm.isCrack3 = true
        TweenMax.fromTo(danger, 0.4, {opacity:0}, {opacity:1, delay: 0.8})
        sceneAns3.destroy()
      })
      // .addIndicators({})
      .addTo(controller_onEnter)
    }
  },
  methods: {
    legend_close() {
      this.isLegend = !this.isLegend
    }
  },
  destroyed() {
    if( window.innerWidth < 768 && (!this.$router.history.current.path=='/') ){
      document.querySelector('.HeaderBar').style.background = '#5B5B5B'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.bold
  font-weight: bold
.mb-1
  margin-bottom: 1rem
.mt-3
  margin-top: 3rem
.mb-3
  margin-bottom: 3rem
.m-0
  margin: 0
.colorGray
  color: #7b7a7a
.colorGreen
  color: #00897b
.result
  width: 100%
  background: #fff
  margin: 0 auto
  padding-bottom: 5rem 
  @media (min-width: 1280px)
    width: 880px
    padding: 0 10% 5rem 10%
    box-sizing: content-box
.container-result
  padding: 0 1rem
  @media (min-width: 768px)
    padding: 0 5rem
#map
  position: relative
  height: 450px
  margin-bottom: 1rem
  @media (min-width: 768px) 
    height: 60vh
.legend_open
  // display: none
  position: relative
  background: red
  width: 20px
  height: 20px
  right: 0
  top: 0
#legend
  position: relative
  width: 60%
  height: 250px
  background: rgba(255, 255, 255, .95)
  box-shadow: -3px -3px 6px 0 rgba(0, 0, 0, 0.16)
  padding: 1rem
  @media (min-width: 768px) 
    width: 30%
    height: 40%
#legend.legend-close
  width: 30px
  height: 45px
  padding: 0
.legend_close
  position: absolute
  right: 0
  top: 0
  cursor: pointer
  width: 30px
  height: 30px
  transition: transform 0.3s ease
  font-size: 30px
  color: #747474
.legend_close-close
  width: 30px
  height: 45px
.legend_close_1
  position: absolute
  border-top: 1px solid #737373
  font-size: 28px
  width: 80%
  left: 50%
  top: 50%
  transform: translate(-50%, -50%) rotate(45deg)

.legend_close_2
  position: absolute
  border-top: 1px solid #737373
  font-size: 28px
  width: 80%
  left: 50%
  top: 50%
  transform: translate(-50%, -50%) rotate(-45deg)
.faIcon
  position: absolute
  right: 0
  bottom: 0
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
.legend_container
  width: 100%
.legend1, .legend2, .legend3
  width: 100%
  display: flex
  align-items: baseline
  margin-bottom: 5px
.legend4, .legend5, .legend6
  width: 100%
  display: flex
  align-items: center
  margin-bottom: 5px
.legend1_legend
  width: 20px
  display: inline-block
  border-top: 4px solid #0D378C
  flex-shrink: 0
  margin-right: 10px
.legend2_legend
  width: 20px
  display: inline-block
  border-top: 4px solid #0080FF
  flex-shrink: 0
  margin-right: 10px
.legend3_legend
  width: 20px
  display: inline-block
  border-top: 4px dashed #707070
  flex-shrink: 0
  margin-right: 10px
.legend4_legend
  width: 16px
  height: 16px
  display: inline-block
  background: #ff0000
  flex-shrink: 0
  margin-right: 10px
.legend5_legend
  width: 16px
  height: 16px
  display: inline-block
  background: #ff6969
  flex-shrink: 0
  margin-right: 10px
.legend6_legend
  width: 16px
  height: 16px
  display: inline-block
  background: #ffdfdf
  flex-shrink: 0
  margin-right: 10px
.legend1_text, .legend2_text, .legend3_text, .legend4_text, .legend5_text, .legend6_text
  display: inline-block
  font-size: 0.9rem
.result_title
  width: 100%
  padding: 1rem 0
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16)
  @media (min-width: 768px) 
    box-shadow: none
.circles
  width: 100%
  display: flex
  flex-wrap: wrap
  align-items: center
.circle
  display: flex
  width: 100%
  align-items: center
  margin-left: 5px
.cricle_container
  width: 200px
  display: flex
  justify-content: space-between
  align-items: center
  @media (min-width: 768px) 
    width: 40%
  p
    margin: 0
.circle_red
  width: 17px
  height: 17px
  margin-right: 13px
  border-radius: 50%
  background: #ff0000
  display: inline-block
  flex-shrink: 0
.answer2, .answer3, .answer4, .answer5
  .circle_red
    @media (min-width: 768px) 
      width: 30px
      height: 30px
      transform: translate(-1rem, -1rem)
.circle_orange
  width: 17px
  height: 17px
  margin-right: 13px
  border-radius: 50%
  background: #f28705
  display: inline-block
  flex-shrink: 0
.answer2, .answer3, .answer4, .answer5
  .circle_orange
    @media (min-width: 768px) 
      width: 30px
      height: 30px
      transform: translate(-1rem, -1rem)
.circle_green
  width: 17px
  height: 17px
  margin-right: 13px
  border-radius: 50%
  background: #41bf9b
  display: inline-block
  flex-shrink: 0
.answer2, .answer3, .answer4, .answer5
  .circle_green
    @media (min-width: 768px) 
      width: 30px
      height: 30px
      transform: translate(-1rem, -1rem)
.answer_imageContainer
  position: relative
  width: 100%
  margin: 0 auto
  display: flex
  flex-wrap: wrap
  justify-content: center
  @media (min-width: 768px) 
    display: flex
    align-items: center
    justify-content: flex-start
    flex-wrap: nowrap
.answer2, .answer3, .answer4, .answer5
  border-top: 1px solid #c9c9c9
  padding-top: 2rem
  @media (min-width: 768px)
    border: 1px solid #c9c9c9
    padding: 2rem
    margin-top: 10px
.answer5
  border-bottom: 1px solid #c9c9c9
.answer2_title, .answer3_title, .answer4_title, .answer5_title
  display: flex
  align-items: center
  margin-left: 5px
  align-items: baseline
  p
    margin: 0
    font-weight: bold
    font-size: 1.4rem
    @media (min-width: 768px) 
      // margin-left: calc(35% - 48px + 2rem)
      margin-left: calc(35% - 48px + 2rem + 15px)
      font-size: 1.6rem
.answer2_image, .answer3_image, .answer4_image, .answer5_image
  position: relative
  margin: 2rem 0
  // width: 50%
  width: 172px
  height: 106px
  @media (min-width: 768px) 
    margin: 0 2rem 0 0
    width: 244px
    height: 188px
    flex-shrink: 0
.house
  position: relative
  z-index: 2
  width: 100%
.dhouse
  width: 100%
.crack
  position: absolute
  top: 0
  left: 0
  z-index: 3
  width: 100%
.worning
  width: 100%
  position: absolute
  top: -30px
  z-index: 1
  left: 0
  border-radius: 50%
  height: 172px
  @media (min-width: 768px)
    top: -40px
    height: 244px
.danger
  position: absolute
  top: 0
  left: 0
.answer2_title-default, .answer3_title-default
  @media (min-width: 768px)
    margin-left: calc(35% - 48px + 2rem - 140px)
</style>
